import { BasicModel } from './basic.model';
import { State } from '@sc/portal.fe.lib.app-components';

export class City extends BasicModel<City> {
    public key?: string;
    public name?: string;
    code?: string;
    description?: string;
    public postalCode: string;
    public state: State;

    constructor(data?: Partial<City>) {
        super({ state: new State(), ...data });
    }
}
